/* eslint-disable @nx/enforce-module-boundaries */
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import Head from 'next/head';
import { forwardRef } from 'react';
import {
  CompanyPagesContext,
  useCompanyPagesContext,
} from 'v4/snippets/company/context';
import {
  JobsListingContext,
  useJobsListingContext,
} from 'v4/snippets/jobs/context';
import { SearchLayout } from 'v4/snippets/search/layout';
import { SearchCompanyPages } from 'v4/snippets/search/pages';

export default forwardRef(({ ...props }, ref) => {
  const pagesCtx = useCompanyPagesContext({});
  const jobsCtx = useJobsListingContext({});
  const { t } = useTranslator();
  return (
    <>
      <JobsListingContext.Provider value={jobsCtx}>
        <CompanyPagesContext.Provider value={pagesCtx}>
          <SearchLayout activeTab={'pages'}>
            <Head>
              <title>{t('otherPage.createFollowCompany') || "Create & Follow Company Pages for Exclusive Updates"}</title>
              <meta
                name="og:title"
                content="Create & Follow Company Pages for Exclusive Updates"
              />
              <meta
                name="description"
                content="Follow the pages of leading companies to stay informed about the latest news, job opportunities, and industry trends. Build your own company page here."
              />
              <meta
                name="keywords"
                content="Social Networking Websites , 20+ Most Popular Social Networking Sites in 2024 , Top Social Media Networks Websites , top 10 social media sites USA, Most Popular Social Media in the US "
              />
              <meta
                name="og:description"
                content="Follow the pages of leading companies to stay informed about the latest news, job opportunities, and industry trends. Build your own company page here."
              />
              <link
                rel="canonical"
                href={`${
                  typeof window !== 'undefined' && window.location.href
                }`}
              />
            </Head>
            <SearchCompanyPages />
          </SearchLayout>
        </CompanyPagesContext.Provider>
      </JobsListingContext.Provider>
    </>
  );
});
